import React from "react";
import {FormattedMessage, injectIntl} from "gatsby-plugin-react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PricingData from "../../content/pricing/index.json";

class SelectedPlan extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedCurrency: "eur",
            selectedPlan: null
        };
    }

    componentDidMount(){

        if (typeof window !== 'undefined' && (this.props.plan === 'Rich' || this.props.plan === 'Geo')) {
            window.location.href = '/signup/start/'
        }

        if (typeof window !== 'undefined' && !localStorage.getItem("notificareSelectedCurrency")) {
            localStorage.setItem("notificareSelectedCurrency", "eur");
        }

        this.setState({
            selectedCurrency: localStorage.getItem("notificareSelectedCurrency")
        });

        if (this.props.plan && (this.props.plan !== 'Rich' || this.props.plan !== 'Geo')) {
            PricingData[this.props.intl.locale].plans.forEach((planType) => {
                planType.planOptions.forEach((plan) => {
                    if (plan.key === this.props.plan) {
                        this.setState({
                            selectedPlan: plan
                        })
                    }
                });
            });
        }
    }

    render() {
        return (
            <div className={`selected-plan`}>
                {this.state.selectedPlan &&
                    <>
                        <div className={`plan-main-info`}>
                            <div className={`title`}>
                                {this.state.selectedPlan.title}
                            </div>
                            <div className={`users`}>
                                <FormattedMessage id="shared.usersLimit" values={{users: this.state.selectedPlan.users}} />
                            </div>
                            <div className={`price`}>
                                <span className={`currency-symbol`}>{this.state.selectedCurrency === "eur" ? "€" : "$"}</span>{this.state.selectedPlan.price[this.state.selectedCurrency]}<span className={`periodicity`}><FormattedMessage id="shared.planPeriodicity" /></span>
                                <div className={`excl-vat`}><FormattedMessage id="shared.exclVat" /></div>
                            </div>
                        </div>
                        <div className={`plan-features`}>
                            {this.state.selectedPlan.features.map((feature, i) => {
                                return (
                                    <div key={i} className={`feature`}><FontAwesomeIcon icon="check" />{feature}</div>
                                )
                            })}
                        </div>
                    </>
                }
            </div>
        )
    }
}

export default injectIntl(SelectedPlan);
